<template>
  <div class="loading">
    <div>Doing important shit</div>
  </div>
</template>

<script>
export default {}
</script>

<style>
.loading {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: grid;
  font-size: 2rem;
  font-weight: bold;
  align-items: center;
  justify-items: center;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  user-select: none;
}
</style>
